A work type for the position.

For example, "FullTime", "PartTime" and "Casual".
